export default () => {
    return (
        <h1>
            <a href="https://snapbeautify.toolooz.com" className="flex items-center text-xl font-bold text-purple-600 dark:text-purple-400">
                <img src="/favicon.svg" alt="图美啦" width="24" height="24" className="mr-2" />
                <span>图美啦</span>
            </a>
        </h1>
    )
};